import { Component } from "@angular/core";

@Component({
  selector: 'tbody[app-dt-body]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-body.component.scss'],
})
export class DtBodyComponent {}